var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5568 6.5796L0.631797 3.6546C0.456068 3.47887 0.456068 3.19394 0.631797 3.0182L1.26818 2.3818C1.44391 2.20605 1.72885 2.20605 1.90458 2.3818L3.875 4.3522L8.09542 0.131797C8.27115 -0.0439322 8.55609 -0.0439322 8.73182 0.131797L9.3682 0.768196C9.54393 0.943924 9.54393 1.22885 9.3682 1.40459L4.1932 6.57962C4.01745 6.75535 3.73253 6.75535 3.5568 6.5796Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.fd6a7e09104bfde151cdc00400c3d56b.svg";
export { ForwardRef as ReactComponent };